export const environment = {
    production: false,
    apiUrl: "https://roaming-ui-backend-development.azurewebsites.net",
    msalConfig: {
        auth: {
            clientId: 'dce50152-ec7c-4399-b2fe-7658d238c9bb',
            tenantId: "42be28b7-241f-4965-ab7a-59309f48eb06",
            validateAuthority: true,
            redirectUri: "https://ui.roaming.emob-test-enbw.com/ui/home",
            postLogoutRedirectUri: "https://ui.roaming.emob-test-enbw.com/ui/logout",
            navigateToLoginRequestUrl: true
        },
        api: {
            resourceScopes: [
                "api://roaming-ui-backend-development/ui.read",
                "api://roaming-ui-backend-development/ui.write"
            ],
        }
    },
};
